var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevator24Dp5F6368Fill0Wght400Grad0Opsz24 = function SvgElevator24Dp5F6368Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280-240h120v-160h40v-180H240v180h40zm60-380q21 0 35.5-14.5T390-670t-14.5-35.5T340-720t-35.5 14.5T290-670t14.5 35.5T340-620m180 100h200L620-680zm100 240 100-160H520zM120-120v-720h720v720zm80-80h560v-560H200zm0 0v-560z"
  })));
};
export default SvgElevator24Dp5F6368Fill0Wght400Grad0Opsz24;